import { TFunction } from "i18next";
import * as yup from "yup";

interface Props {
  t: TFunction;
}

const InstitutionDetailsValidationSchema = ({ t }: Props) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
    pedagogicalYearInstitutionId: yup.mixed().required(requiredMsg),
  });
};

export default InstitutionDetailsValidationSchema;
